import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';

import {
  DEFAULT_CAMPAIGN_STATE,
  GENDERS_MAP_FROM,
  GENDERS_MAP_TO,
  PACKAGES_LIST
} from '../constants';

import { err, ok } from 'utils/result';

import type {
  Campaign,
  Result
} from 'types';
import { CcmCreatorlesCampaign } from 'modules/campaigns/components/ccm/types/CcmCampaign.type';
import type { CreatorlessCampaign } from '../types';

type ImportantCampaignFields = Pick<Campaign,
  | 'countries'
  | 'genders'
  | 'timeline'
  | 'name'
  | 'packageName'
  | 'collectionLink'
>

export function hasChanges(form: CreatorlessCampaign): boolean {
  return !isEqual(form, cloneDeep(DEFAULT_CAMPAIGN_STATE));
}

export function mapCampaignToCreatorlessCampaign({
  countries,
  genders,
  timeline,
  name,
  packageName,
  collectionLink
}: ImportantCampaignFields): Result<CreatorlessCampaign, string> {
  if (isNil(countries) || countries.length === 0) {
    return err('CCM Campaign must have countries!');
  }

  if (isNil(genders) || genders.length === 0 || isNil(GENDERS_MAP_FROM[(genders)[0]])) {
    return err('CCM Campaign must target female or male audience!');
  }

  if (isNil(timeline)) {
    return err('CCM Campaign must have a timeline with a valid go-live date!');
  }

  if (isNil(packageName) || !PACKAGES_LIST.includes(packageName)) {
    return err('CCM Campaign must have a package assigned!');
  }

  if (isNil(collectionLink) || collectionLink.length === 0) {
    return err('CCM Campaign must have a collection link!');
  }

  return ok({
    countries,
    name,
    gender: GENDERS_MAP_FROM[(genders)[0]],
    goLiveDate: timeline.taskContentGoLiveDate,
    package: packageName,
    zalandoLink: collectionLink
  });
}

export function mapCreatorlessCampaignToCcmCampaign(
  form: CreatorlessCampaign
): Result<CcmCreatorlesCampaign, string> {
  if (isNil(form.gender) || form.gender.length === 0 || isNil(GENDERS_MAP_TO[(form.gender)[0]])) {
    return err('CCM Campaign must target female or male audience!');
  }

  if (form.goLiveDate === null) {
    return err('CCM Campaign must have a timeline with a valid go-live date!');
  }

  return ok({
    campaignType: 'ccm_creatorless',
    name: form.name,
    campaignPackage: form.package,
    countries: form.countries,
    genders: GENDERS_MAP_TO[form.gender],
    collectionLink: form.zalandoLink,
    goLiveDate: form.goLiveDate
  });
}
